module.exports = __webpack_public_path__ + "img/iphone-map-SPAIN-es.b1bbebd0.webp";